import FocusTrap from 'focus-trap-react';
import React, { type ReactNode } from 'react';

type Props = {
  className: string;
  children: ReactNode;
  setIsSearchExpanded: (b: boolean) => void;
  trapFocus: boolean;
};

export default function ExpandedSearchContainer({ className, children, setIsSearchExpanded, trapFocus }: Props) {
  return (
    <>
      <FocusTrap active={trapFocus}>
        <div>
          {/* backdrop */}
          <div
            role="presentation"
            className="fixed left-0 top-0 h-screen w-screen bg-neutral-50 opacity-50"
            onClick={() => setIsSearchExpanded(false)}
          />
          {/* extending container styles as well to not affect the layout and setting fixed for expanded container */}
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div
            id="expanded-search-container"
            className={`${className} !fixed animate-search-expand-open lg:h-[9.65rem]`}
            onKeyDown={e => {
              // close on escape key press
              if (e.key === 'Escape') {
                setIsSearchExpanded(false);
              }
            }}
          >
            {children}
          </div>
        </div>
      </FocusTrap>
    </>
  );
}
